<template>
	<div :class="{ promotions: true, 'promotions--open': isOpen }">
		<o-button class="promotions-toggle" @click="isOpen = !isOpen">
			<o-icon :icon="isOpen ? 'chevron-right' : 'chevron-left'"></o-icon>
			{{ message }}
		</o-button>
		<aside>
			<slot></slot>
		</aside>
	</div>
</template>
<script>
	import { getCurrentInstance, ref, computed, watch, onMounted, inject } from "vue";
	import navSection from "@/components/navbar/navSection.vue";
	export default {
		props: {
			open: {
				type: Boolean,
				default: true
			}
		},
		setup(props, context) {
			const global = getCurrentInstance()?.appContext.config.globalProperties;

			const api = ref(process.env.VUE_APP_API);

			const isOpen = ref(props.open);
			const message = computed(() => {
				return isOpen.value ? "Hide extra content" : "View extra content";
			});

			const pathArray = computed(() => {
				const arr = global.$route.path.split("/");
				if (arr[0] === "") {
					arr.shift();
					arr[0] = "/" + arr[0];
				}
				return arr;
			});

			const sidebarOptions = ref([]);

			for (const child of global.$router.options.routes[0].children) {
				if (child.path !== "/") {
					sidebarOptions.value.push(child);
				}
			}

			const currentRoot = computed(() => {
				return global.$route.matched[1].path;
			});
			const currentRootOptions = computed(() => {
				const c = global.$router.options.routes[0].children;
				return c.find((o) => o.path === currentRoot.value).children;
			});

			return {
				api,
				isOpen,
				message,
				pathArray,
				sidebarOptions,
				currentRootOptions,
				currentRoot
			};
		}
	};
</script>
<style lang="scss">
	@use "@/assets/css/globalVars.scss" as *;

	div.promotions {
		& aside > .prime-card > .prime-card-content {
			padding: 0 $margin-element-small;

			& > .prime-card {
				& > header > h2 {
					font-size: 1.25rem;
					font-weight: 600;
				}

				& > img {
					height: 10rem;
					object-fit: cover;
				}
			}
		}

		& > .promotions-toggle {
			z-index: 40;
			margin-top: $margin-body-large;
			width: $margin-body-medium;
			height: auto;
			padding: none;
			border-radius: $radius-medium 0 0 $radius-medium;
			vertical-align: middle;
			background-color: white;
			color: $text-black;

			& .button-wrapper > span {
				writing-mode: vertical-rl;
				text-orientation: sideways;

				& > span.icon {
					margin-bottom: 0.2em;
					width: 2em;
					height: 2em;
					border-radius: 1em;
					background-color: $boyden-blue-lighter;
					color: $text-blue;
				}
			}

			&:focus:not(:active) {
				box-shadow: none;
			}
		}

		// &--open > .promotions-toggle {
		// 	background-color: transparent !important;
		// 	box-shadow: none !important;
		// 	//transform: translateY(#{$margin-body-tiny});
		// 	margin-left: 0;
		// 	width: 0;
		// 	padding: 0;

		// 	& .button-wrapper > span > span.icon {
		// 		border: 1px solid;
		// 	}
		// }
	}
</style>

<style lang="scss" scoped>
	@use "@/assets/css/globalVars.scss" as *;

	.promotions {
		width: auto;
		height: 100%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-end;
		overflow-y: auto;

		& aside {
			@include reset-element;
			z-index: 1;
			width: 0;
			height: 100%;
			min-height: 50vh;

			background-color: white;
			overflow-y: auto;
			transition: width 0.25s;
		}

		&--open {
			& aside {
				width: $promotions-width;
			}
		}

		&:not(.promotions--open) {
			right: -16px;
		}
	}

	@media screen and (max-width: 64rem) {
		.promotions {
			display: none;
		}
	}
</style>
